module.exports = __webpack_public_path__ + "img/s00155.febd26b6.png";